import axios from 'axios'

axios.defaults.headers = {
  'Content-Type': 'application/json'
}

export default {
  fetchCollection (newsSource, count = 10) {
    var newsFeed = '';

    switch (newsSource) {
      case 'flatsixes':
        newsFeed = 'https://flatsixes.com/feed/';
        break;
      case 'local':
        newsFeed ='https://patch.com/feeds/aol/california/missionviejo';
        break;
      case 'investopedia':
        newsFeed ='https://www.investopedia.com/feedbuilder/feed/getfeed/?feedName=rss_headline';
        break;
      case 'cnbc-finance':
        newsFeed = 'https://search.cnbc.com/rs/search/combinedcms/view.xml?partnerId=wrss01&id=10000664';
        break;
      case 'macrumors':
        newsFeed = 'https://feeds.macrumors.com/MacRumors-Front';
        break;
      case 'marketwatch':
        newsFeed ='https://www.marketwatch.com/rss/topstories';
        break;
      case 'porschenewsroom':
        newsFeed = 'https://www.porsche.com/international/rss/';
        break;
      case 'rennlist':
        newsFeed = 'https://rennlist.com/forums/external.php?type=RSS2&forumids=113';
        break;
      case 'msnbc-top':
        newsFeed = 'https://www.cnbc.com/id/100003114/device/rss/rss.html';
        break;
      case 'msnbc-world':
        newsFeed = 'https://www.cnbc.com/id/100727362/device/rss/rss.html';
        break;
      case 'msnbc-us':
        newsFeed = 'https://www.cnbc.com/id/15837362/device/rss/rss.html';
        break;
    }


    return axios.get('https://api.rss2json.com/v1/api.json', {
      params: {
        rss_url: newsFeed,
        api_key: 'wd8jfv3modteiczerjxtbhhifsslr2zt5o4pg5br',
        count: count,
        format: 'json'
      }
    })
      .then(response => {
        const data = response.data
        // rss2json returns { status: 'ok' } on success — reject on error
        if (data && data.status && data.status !== 'ok') {
          return Promise.reject(new Error(data.message || 'RSS fetch failed'))
        }
        return data
      })
  },

  fetchNews (source, feed) {
    return axios.get(feed, {
      params: {
        format: 'json'
      }
    })
      .then(response => {
        return response.data
      })
  }
}
